import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { paletteVariants, } from '@/components/molecules/Layout/LayoutContainer';
import TransitionPalette from '@/components/molecules/TransitionPalette/TransitionPalette';
import { Blocks } from '@/components/organisms/Blocks/Blocks';
import Footer from '@/components/organisms/Footer/Footer';
import Header from '@/components/organisms/Header/Header';
import SectorHero from '@/components/organisms/SectorHero/SectorHero';
import { PageContainer } from '@/components/utils/PageContainer';
import { cn } from '@/utils/cn';
import { SectorServiceInterestContext } from '@/utils/sectorServiceInterestStore';
const SectorPage = (props) => {
    console.log(props);
    const { header, footer, palette, main, animation, heroPalette, categories } = props || {};
    // Render categories (service of interest) as string if available
    const selectedCategories = categories && categories.length > 0
        ? categories.map(cat => cat.displayValue).join(', ')
        : '';
    return (_jsx(SectorServiceInterestContext.Provider, { value: selectedCategories, children: _jsxs(PageContainer, { ...props, children: [_jsxs("div", { className: 'grid grid-rows-[min-content_1fr]', children: [header && (_jsx(Header, { block: header, paletteClassName: cn(paletteVariants({ palette: heroPalette || palette })), className: "col-start-1 row-start-1" })), _jsxs(TransitionPalette, { active: animation === 'transition-palette', palette: palette, children: [_jsx(SectorHero, { block: props, palette: heroPalette }), _jsx(Blocks, { blocks: main })] })] }), footer && _jsx(Footer, { block: footer })] }) }));
};
export default SectorPage;
